import dayjs from 'dayjs';
import React from 'react';
import { isToday, isYesterday } from '../../helpers/dateTimes';
import { CallbackTranslation } from '../../locale/localizationContext';
import { AttemptState, CalculatedOrderStatus, Delay } from '../../models';
import {
  IconProps,
  BlockedIcon,
  FailedIcon,
  SuspendedIcon,
  CheckIcon,
} from '../Icons';

export function getFormattedDate(
  dateTime: dayjs.Dayjs | undefined | null,
  t: CallbackTranslation
): string | undefined {
  if (dateTime && isToday(dateTime!))
    return t('summaryBox.today').toUpperCase();
  if (dateTime && isYesterday(dateTime))
    return t('summaryBox.yesterday').toUpperCase();

  return dateTime?.format('DD/MM');
}

export function getFormattedTime(
  dateTime: dayjs.Dayjs | undefined | null
): string | undefined {
  return dateTime?.format('HH:mm');
}

export function getTextFromAttemptNumber(
  attemptNumber: AttemptState | undefined,
  orderState: CalculatedOrderStatus,
  delay: Delay | undefined,
  t: CallbackTranslation
): string {
  if (orderState === CalculatedOrderStatus.Fulfilled) {
    switch (delay) {
      case Delay.No:
        return t('summaryBox.fulfilledNoDelay').toUpperCase();
      case Delay.Slight:
        return t('summaryBox.fulfilledSlightDelay').toUpperCase();
      case Delay.Major:
        return t('summaryBox.fulfilledMajorDelay').toUpperCase();
      default:
        return t('summaryBox.fulfilledNoDelay').toUpperCase();
    }
  }

  switch (attemptNumber) {
    case AttemptState.First:
      return t('summaryBox.firstAttempt').toUpperCase();
    case AttemptState.Second:
      return t('summaryBox.secondAttempt').toUpperCase();
    case AttemptState.Third:
      return t('summaryBox.thirdAttempt').toUpperCase();
    case AttemptState.Fourth:
      return t('summaryBox.fourthAttempt').toUpperCase();
    case AttemptState.Done:
      return t('summaryBox.done').toUpperCase();
    default:
      return '';
  }
}

export function getBorderColorClassByState(
  orderState: CalculatedOrderStatus
): string {
  switch (orderState) {
    case CalculatedOrderStatus.Blocked:
      return 'order-summary-box--border-danger';
    case CalculatedOrderStatus.ToReschedule:
      return 'order-summary-box--border-failed';
    case CalculatedOrderStatus.Fulfilled:
      return 'order-summary-box--border-fulfilled';
    case CalculatedOrderStatus.Suspended:
      return 'order-summary-box--border-warning';
    default:
      return '';
  }
}

export function getIconByState(
  orderState: CalculatedOrderStatus
): React.ComponentType<IconProps> | undefined {
  switch (orderState) {
    case CalculatedOrderStatus.Blocked:
      return BlockedIcon;
    case CalculatedOrderStatus.ToReschedule:
      return FailedIcon;
    case CalculatedOrderStatus.Fulfilled:
      return CheckIcon;
    case CalculatedOrderStatus.Suspended:
      return SuspendedIcon;
    default:
      return undefined;
  }
}

export function getSummaryText(
  orderState: CalculatedOrderStatus,
  t: CallbackTranslation
): string | undefined {
  if (orderState === CalculatedOrderStatus.Suspended)
    return t('summaryBox.suspendedShipment');
  if (orderState === CalculatedOrderStatus.Masked)
    return t('summaryBox.masked');
  if (orderState === CalculatedOrderStatus.ScheduledReception)
    return t('summaryBox.scheduledReception');
  return undefined;
}
